import { lazy } from 'react';

export const variationMapper = {
  DownloadAll: lazy(() => import('./variants/DownloadContent')),
};
